import { Text, View, Image } from 'components';
import Base, { Config } from 'components/eswj/Base';
import Ico from 'components/Ico';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './index.module.scss';
import cx from 'classnames'


interface State {
  vipList: any[]
  showView: boolean
  viewImage: any;
  vipType: string;
  currentId: number
}

export default class Vip extends Base<any, State>  {
  public config: Config = {
    navigationBarTitleText: '加入会员'
  };

  public state: State = {
    vipList: [],

    showView: false,
    viewImage: '',
    vipType: 'free',
    currentId: 0
  };


  public async didMount() {
    await this.getUserInfo();

  }

  public render() {
    const { vipList, showView, viewImage, currentId } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        
        
        <View className={styles.page} style={vipList.length == 0? {display: 'none'}: {}}>
          <View className={styles.tabBox}>
            {vipList.map((e, ind) => (
              <View className={this.cx(styles.tabItem, styles['tabItem'+ind], {
                [styles.active]: currentId == e.id
              })} onClick={this.handleStateChange.bind(null, 'currentId', e.id)}>
                {e.valid > 360 && <View className={styles.discont}>推荐</View>}
                <View className={styles.itemInner}>
                  <View className={styles.checkIco}>
                    <Ico src={this.assets.eswj.checkWhite} size={32} className={styles.ico} />
                  </View>
                  <View className={styles.h2}>
                    <Text>{e.name}</Text>
                  </View>
                  <View className={styles.h5}>
                    <Text>（有效期{parseInt(String(e.valid/30))}个月）</Text>
                  </View>
                  <View className={styles.h5}>
                    <Text>&nbsp;&nbsp;{e.info_list.length}大特权</Text>
                  </View>
                </View>
              </View>
            ))}
          </View>
          

          <View className={styles.lists}>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'wxGroup') || {}).status
            })} onClick={() => {
              return;
            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon1} size={41} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                    <Text className={styles.red}>
                      {(this.vipSelectedInfo.find(e => e.column == 'wxGroup') || {}).value || ''}万+微信群
                    </Text>
                    客户展示
                  </Text>
                  
                </View>
              </View>
            </View>
            
            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'wxCircle') || {}).status
            })} onClick={() => {

            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon2} size={30} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                    <Text className={styles.red}>朋友圈车源自动同步51平台</Text>
                  </Text>
                  <View className={styles.tag}>
                  （覆盖{(this.vipSelectedInfo.find(e => e.column == 'wxCircle') || {}).value || ''}+人）
                  </View>
                </View>
              </View>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'preferred') || {}).status
            })} onClick={this.look.bind(null, 2)}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon3} size={41} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                    成为优选车商，名片置顶显示
                  </Text>
                </View>
              </View>
              <Text className={styles.rig}>{'介绍>>'}</Text>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'show') || {}).status
            })} onClick={this.look.bind(null, 2)}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon4} size={39} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                    二手广告优先展示给
                    <Text className={styles.red}>
                      {(this.vipSelectedInfo.find(e => e.column == 'show') || {}).value || ''}
                      万+{'挖机'}客户
                    </Text>
                  </Text>
                </View>
              </View>
              <Text className={styles.rig}>{'介绍>>'}</Text>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'new') || {}).status
            })} onClick={() => {

            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon5} size={37} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  最新“求购{'挖机'}”信息
                  </Text>
                </View>
              </View>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'index') || {}).status
            })} onClick={() => {

            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon6} size={45} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  首页“会员推荐”展示
                  </Text>
                </View>
              </View>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'direct') || {}).status
            })} onClick={() => {

            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon7} size={40} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  一手“机主直卖”电话
                  </Text>
                </View>
              </View>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'saleClass') || {}).status
            })} onClick={this.newPage.bind(null, 'douyin')}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon8} size={36} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  价值
                  {(this.vipSelectedInfo.find(e => e.column == 'saleClass') || {}).price || ''}
                  元快手/抖音卖二手机教程
                  </Text>
                </View>
              </View>
              <Text className={styles.rig}>{'介绍>>'}</Text>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'shop') || {}).status
            })} onClick={this.look.bind(null, 1)}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon9} size={37} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  专属二手店铺，更吸引人
                  </Text>
                </View>
              </View>
              <Text className={styles.rig}>{'介绍>>'}</Text>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'remind') || {}).status
            })} onClick={() => {

            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon10} size={37} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  查看二手机线索提醒
                  </Text>
                </View>
              </View>
            </View>

            <View className={this.cx(styles.lis, {
              [styles.disabled]: !(this.vipSelectedInfo.find(e => e.column == 'onePro') || {}).status
            })} onClick={() => {

            }}>
              <View className={styles.icoBox}><Ico src={this.assets.eswj.vipIcon11} size={34} /></View>
              <View className={styles.mid}>
                <View className={styles.p}>
                  <Text>
                  专属客服一对一服务
                  </Text>
                </View>
              </View>
            </View>



            <View className={styles.notcieTxt}>
              <Text className={styles.txt}><Text className={styles.b}>注意：</Text>会员服务在购买后不支持退订、转让，请确认后购买！</Text>
            </View>

            
          </View>


          <View className={styles.fixedRight}>
            <a href="tel:15715718487" className={this.cx(styles.btn, styles.green)}>
              <Ico src={this.assets.eswj.phoneGreen} 
                size={35}
              />
              <View className={styles.content}>
                <Text>联系</Text>
                <Text>客服</Text>
              </View>
            </a>
          </View>
          
          
          <View className={styles.fixedBtm}>
            <View className={styles.btnOuter}>
                <View className={styles.le}>
                  <Text>
                    {this.vipSelected.name}
                    <Text className={styles.sm}>¥</Text>
                    <Text className={styles.b}>{this.vipSelected.price}</Text>
                  </Text>
                </View>
                <View className={styles.ri} onClick={this.join}>
                  <Text>确认支付</Text>
                </View>
            </View>
          </View>
          
        </View>


        
        {showView && (
          <View className={styles.viewBox}>
            <View className={styles.viewImg}>
              <Image src={viewImage} className={styles.img}/>
            </View>
            <Image src={this.assets.eswj.regclose} className={styles.regclose} onClick={this.toggleView.bind(null,0)}/>
          </View>
        )}

        

        
      </View>
    );
  }


  private get vipSelected() {
    const { vipList, currentId } = this.state
    let res:any =  vipList.find(e => e.id == currentId) || {}
    return res
  }
  private get vipSelectedInfo() {
    return this.vipSelected? this.vipSelected.info_list || []: []
  }

  private handleStateChange = (key:any, val:any) => {
    let value = val;

    if (val && val.detail) {
      value = val.detail.value;
    }

    const obj:any = {
      [key]: value,
    }
    this.setState(obj);
  }



  private look = (ind:number) => {
    this.setState({
      viewImage: this.assets.eswj['lookImg'+ind]
    })
    console.log(this.assets.eswj['lookImg'+ind])
    this.toggleView(1)
  }

  private toggleView = (num:number = 0) => {
    this.setState({
      showView: !!num
    })
  }



  private newPage = e => {
    let url;
    switch (e) {
      case "douyin":
        url = "https://mp.weixin.qq.com/s/qa1-xYlV2Cq3yaUqFUziNQ";
        break;
      // case "yun":
      //   url = "https://mp.weixin.qq.com/s/mM7wHspvQYdBk5_hVJFoqw";
      //   break;
    }
    window.open(url, '_blank')
  }


  private getUserInfo = async () => {
    const { data } = await this.apiClient.base.profile();

    if(data && data.id) {
      const res = await this.apiClient.base.vipInfo({mid: data.id});
      this.setState({
        vipType: res.data.type || 'free'
      })
    }
    this.getVipList()
  }

  private getVipList = async () => {
    const { body } = await this.apiClient.base.vipList();

    this.setState({
      vipList: body || [],
      currentId: body[0].id
    })
  }

  

  private join = async() => {
    const { currentId } = this.state

    // if (vipType == "silver" || vipType == "silver_half_time" || vipType == "diamond") {
    //   toast.success('您已开通会员',{
    //     position: toast.POSITION.TOP_RIGHT,
    //     autoClose: 1500,
    //     closeButton: false,
    //   })
    //   return;
    // }
    
    if(!currentId) {
      toast.error('请选择需要的会员',{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }


    const response = await this.apiClient.base.buyVip(
      {
        id: currentId,
      }
    );

    if (response.status !== 10000) {
      alert(response.msg || '网络错误，请重试')
      return;
    }

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        toast.success('支付成功！',{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
        this.getUserInfo();
      }
    }).catch(err => {
      console.log(err)
      toast.error('支付失败！',{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
    });

    
  }

}
